// Simple approach for password recovery form handling
document.addEventListener('DOMContentLoaded', function() {
  // Check for URL parameters on page load
  const urlParams = new URLSearchParams(window.location.search);
  
  // Check for recover success parameter
  if (urlParams.get('recover_success') === 'true') {
    window.toast.success('<span class="reset-message-line1">ส่งลิงก์รีเซ็ตรหัสผ่านแล้ว</span><span class="reset-message-line2">กรุณาตรวจสอบอีเมลของคุณ</span>');
    
    // Remove the parameter from URL to prevent showing the message again on refresh
    const url = new URL(window.location.href);
    url.searchParams.delete('recover_success');
    window.history.replaceState({}, document.title, url.toString());
  }
  
  // Check for recover error parameter
  if (urlParams.has('recovery_error')) {
    window.toast.error('ไม่พบบัญชีผู้ใช้จากอีเมลนั้น');
    
    // Remove the parameter from URL
    const url = new URL(window.location.href);
    url.searchParams.delete('recovery_error');
    window.history.replaceState({}, document.title, url.toString());
  }

  // Setup form handler for password recovery
  function setupPasswordResetHandler() {
    // Try to find the form using various selectors
    const passwordForm = document.querySelector('#recover_customer_password') || 
                         document.querySelector('form[action*="/account/recover"]');

    if (!passwordForm) {
      setTimeout(setupPasswordResetHandler, 1000);
      return;
    }

    // If we already setup this form, don't do it again
    if (passwordForm.dataset.handlerAttached === 'true') {
      return;
    }

    // Mark this form as having a handler attached
    passwordForm.dataset.handlerAttached = 'true';

    // Find the submit button
    const submitButton = passwordForm.querySelector('button[type="submit"]');
    const originalButtonText = submitButton ? submitButton.textContent : 'ส่ง';

    // Store original form attributes
    const originalAction = passwordForm.getAttribute('action');
    const originalMethod = passwordForm.getAttribute('method');

    // Prepare the recover form for traditional submission (redirect method)
    passwordForm.addEventListener('submit', function(e) {
      // Only perform basic validation, then allow the form to submit normally
      const emailInput = passwordForm.querySelector('input[name="email"]');
      
      // Validate email
      if (!emailInput || !emailInput.value || !emailInput.value.includes('@')) {
        e.preventDefault();
        window.toast.error('กรุณาระบุอีเมลที่ถูกต้อง');
        return false;
      }
      
      // Update button state but allow the traditional form submission
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'กำลังส่ง...';
      }
      
      // Ensure the form has the correct action and method attributes
      if (originalAction && originalAction.includes('/account/recover')) {
        passwordForm.setAttribute('action', originalAction);
      } else {
        passwordForm.setAttribute('action', '/account/recover');
      }
      
      if (originalMethod) {
        passwordForm.setAttribute('method', originalMethod);
      } else {
        passwordForm.setAttribute('method', 'post');
      }
      
      // Allow the default form submission
      return true;
    });
    
    // Add CSRF token to form if needed
    const formData = new FormData(passwordForm);
    if (!formData.has('authenticity_token')) {
      // Try to get CSRF token from meta tag
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ||
                      document.querySelector('[name="csrf-token"]')?.getAttribute('content');
      
      if (csrfToken) {
        const tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'authenticity_token';
        tokenInput.value = csrfToken;
        passwordForm.appendChild(tokenInput);
      }
    }
  }
  
  // Function to close any open customer sidebar
  function closeCustomerSidebar() {
    // Method 1: Click close button
    const closeButtons = document.querySelectorAll('.halo-sidebar-close, .popup-close, [data-close-sidebar]');
    if (closeButtons.length > 0) {
      closeButtons[0].click();
      return;
    }
    
    // Method 2: Remove body classes
    document.body.classList.remove('customer-sidebar-open', 'sidebar-open');
    
    // Method 3: Close sidebars by class
    const sidebars = document.querySelectorAll('.halo-sidebar-wrapper.is-open, .halo-popup-modal.is-open');
    sidebars.forEach(function(sidebar) {
      sidebar.classList.remove('is-open');
    });
  }
  
  // Initial setup
  setupPasswordResetHandler();
  
  // Setup when sidebar opens
  document.addEventListener('click', function(e) {
    const target = e.target;
    
    // If clicking on customer login triggers
    if (target.matches('[data-target="customer-sidebar"], [data-open-auth-sidebar]') ||
        (target.closest && target.closest('[data-target="customer-sidebar"], [data-open-auth-sidebar]'))) {
      setTimeout(setupPasswordResetHandler, 500);
    }
    
    // If clicking on recover password tab/link
    if (target.matches('.tab-reset, a[href*="#recover"]') ||
        (target.closest && target.closest('.tab-reset, a[href*="#recover"]'))) {
      setTimeout(setupPasswordResetHandler, 500);
    }
  });
  
  // Watch for DOM changes that might indicate sidebar opening
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
        const target = mutation.target;
        if (target.classList.contains('is-open') && 
            (target.classList.contains('halo-sidebar-wrapper') || 
             target.classList.contains('halo-popup-modal'))) {
          setTimeout(setupPasswordResetHandler, 500);
        }
      }
    }
  });
  
  // Start observing the document
  observer.observe(document.body, {
    attributes: true,
    subtree: true,
    attributeFilter: ['class']
  });
});

